(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["broadway-style-options"]) return;
  try {
    
if (!customElements.get('broadway-style-options')) {
customElements.define('broadway-style-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});

    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('broadway-style-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._broadway_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Broadway '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_broadway_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='broadway-'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._broadway_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('broadway:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crucci-project-builder"]) return;
  try {
    
if (!customElements.get('crucci-project-builder')) {
customElements.define('crucci-project-builder', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(event.target.name==='kit_style'&&this.config.hideSymfonieByStyle?.[Number(event.target.value)]&&this.form.elements.kit_needles.value==='symfonie')this.form.elements.kit_needles.value='zing';
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});

    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesByStyle?.[Number(this.form.elements.kit_style.value||0)]?.[brand]||this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    this.querySelector('[name=kit_needles][value=symfonie]').closest('label').hidden=!!this.config.hideSymfonieByStyle?.[Number(this.form.elements.kit_style.value||0)];
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyByStyle?.[key]?.[Number(this.form.elements.kit_style.value||0)]||this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('crucci-project-builder'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._crucci_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Crucci '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_crucci_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='crucci-'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._crucci_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('crucci:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hayfield-style-options"]) return;
  try {
    
if (!customElements.get('hayfield-style-options')) {
customElements.define('hayfield-style-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});

    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('hayfield-style-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._hayfield_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Hayfield '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_hayfield_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='hayfield-'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._hayfield_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('hayfield:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }

  // Read vars from attributes
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;

      // set correct image shape
      if(adv_ratio == 'true'){
        var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
        var ar = $firstImage.width() / $firstImage.outerHeight();
        $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
          var thisAr = $(this).width() / $(this).outerHeight();
          if(
            (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
            (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
          ) {
            ar = thisAr;
          }
        });
        if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
          $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
        }
      }

      // init masonry layout
      $(document).trigger('loadmasonry');
    }
  };
  request.send();
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "related-products") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "related-products") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-accessory-builder"]) return;
  try {
    
if (!customElements.get('rowan-accessory-project')) {
customElements.define('rowan-accessory-project', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size')this.form.elements.kit_own_cable.checked=false;
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:slot.counts[size]}));
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x)items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=Object.values(this.config.packages).some(pack=>pack.some(x=>x.kind==='cable'));
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.map(x=>x.label+': '+this.ballQuantity(x.counts[si])).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(slot.counts[si]));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,s.size).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-accessory-project'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-accessory-options"]) return;
  try {
    
if (!customElements.get('rowan-accessory-options')) {
customElements.define('rowan-accessory-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:slot.counts[size]}));
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.map(x=>x.label+': '+this.ballQuantity(x.counts[si])).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(slot.counts[si]));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-accessory-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-colour-builder"]) return;
  try {
    
if (!customElements.get('rowan-colour-project')) {
customElements.define('rowan-colour-project', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label+' cm'})),this.t('choose_size'));
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:slot.counts[size]}));
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.config.packages[needle].filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x)items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const hasCables=Object.values(this.config.packages).some(pack=>pack.some(x=>x.kind==='cable'));
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.t('finished_chest')+' '+this.config.finished[si]+'cm · '+this.config.colourSlots.map(x=>x.label+': '+this.ballQuantity(x.counts[si])).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(slot.counts[si]));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    for(const brand of ['zing','symfonie']){
      const pack=this.config.packages[brand].filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.config.packages[s.needle].filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-colour-project'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.config.sizes[selection.size]+' cm';
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.config.sizes[current.size]+' cm';
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-kit-pilot"]) return;
  try {
    
if (!customElements.get('rowan-kit')) {
  customElements.define('rowan-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-gallery-src]').forEach(thumb => thumb.addEventListener('click', () => {
        const hero = this.querySelector('.rk-hero');
        hero.removeAttribute('srcset');hero.src = thumb.dataset.gallerySrc;hero.alt = thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
        this.querySelectorAll('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }));
      this.data = JSON.parse(this.querySelector('[data-kit-data]').textContent);
      this.form = this.querySelector('form');
      this.button = this.querySelector('.rk-add');
      this.status = this.querySelector('[data-status]');
      this.cartLink = this.querySelector('.rk-view-cart');
      this.counts = [8,9,10,11,12,14,15,16,17];
      this.finished = [90,100,110,121,130,140,150,161,171];
      this.busy = false;
      this.locked = false;
      this.form.addEventListener('change', () => { if (!this.locked && !this.busy) { this.status.textContent = ''; this.render(); } });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.addProject(); });
      this.render();
    }
    text(key, replacements = {}) {
      let value = this.data.strings[key] || key;
      Object.entries(replacements).forEach(([name, replacement]) => { value = value.replaceAll('__' + name + '__', String(replacement)); });
      return value;
    }
    money(amount) { return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency', currency:this.data.currency || 'NZD'}).format(amount / 100); }
    product(index) { return this.data.products[index]; }
    variant(index, id) { return this.product(index).variants.find(v => String(v.id) === String(id)); }
    selection() {
      const f = new FormData(this.form);
      const mode = f.get('kit_mode');
      if (mode === 'pattern') return {mode, items:[{variant:this.product(0).variants[0],quantity:1,label:this.text('pattern_line')}], ready:true, size:-1, style:'none', balls:0, ownCable:false};
      const ownCable = f.has('kit_own_cable');
      const rawSize = f.get('kit_size');
      const size = rawSize === '' ? -1 : Number(rawSize);
      const yarn = this.variant(1, f.get('kit_shade'));
      const style = f.get('kit_needles');
      const items = [];
      if (size < 0 || size > 8 || !yarn) return {mode,items, ready:false, size, style,ownCable};
      const balls = this.counts[size];
      if (f.has('kit_pattern')) items.push({variant:this.product(0).variants[0], quantity:1, label:this.text('pattern_line')});
      items.push({variant:yarn, quantity:balls, label:this.text('yarn_line',{BALLS:balls,COLOUR:yarn.title})});
      if (style !== 'none') {
        const index = style === 'zing' ? 2 : 3;
        items.push({variant:this.variant(index, style === 'zing' ? 47734023913693 : 46061736820957), quantity:1, label:this.text('tips_line',{BRAND:style === 'zing' ? 'KnitPro Zing' : 'KnitPro Symfonie'})});
        if (!ownCable) items.push({variant:this.variant(4,f.get('kit_cable')), quantity:1, label:this.text('cable_line',{LENGTH:this.form.elements.kit_cable.selectedOptions[0].textContent})});
      }
      if (f.has('kit_dpn')) items.push({variant:this.variant(5,47942764855517), quantity:1, label:this.text('dpn_line')});
      return {mode,items,ready:true,size,style,yarn,balls,ownCable};
    }
    stockProblems(selection, cart = {items:[]}) {
      return selection.items.flatMap(item => {
        const v = item.variant;
        if (!v || !v.available) return [item.label + ': ' + this.text('unavailable')];
        const existing = cart.items.filter(line => Number(line.variant_id) === Number(v.id)).reduce((sum,line) => sum+line.quantity,0);
        if (v.tracked && v.policy !== 'continue' && v.quantity - existing < item.quantity) return [this.text('stock_variant',{ITEM:v.title,REMAINING:Math.max(0,v.quantity-existing),REQUIRED:item.quantity})];
        return [];
      });
    }
    render() {
      const patternOnly = this.form.elements.kit_mode.value === 'pattern';
      const projectFields = this.querySelector('[data-project-fields]');
      projectFields.hidden = patternOnly;
      projectFields.querySelectorAll('fieldset').forEach(fieldset => {fieldset.disabled = patternOnly;});
      this.querySelector('[data-pattern-note]').hidden = !patternOnly;
      this.querySelector('[data-summary-title]').textContent = this.text(patternOnly ? 'pattern_summary' : 'summary_title');
      this.querySelector('[data-pattern-price]').textContent = this.money(this.product(0).variants[0]?.price || 0);
      const s = this.selection();
      this.querySelector('[data-cable-wrap]').hidden = s.style === 'none';
      this.querySelector('[data-cable-selector]').hidden = s.ownCable;
      this.querySelector('[data-own-cable-note]').hidden = !s.ownCable;
      const size = Number(this.form.elements.kit_size.value);
      this.querySelector('[data-fit]').textContent = this.form.elements.kit_size.value === '' ? '' : this.text('fit',{CM:this.finished[size],BALLS:this.counts[size]});
      const chosenYarn = this.variant(1,new FormData(this.form).get('kit_shade'));
      if (chosenYarn) this.querySelector('[data-shade-name]').textContent = chosenYarn.title;
      const optionVariants = {zing:this.variant(2,47734023913693),symfonie:this.variant(3,46061736820957),dpn:this.variant(5,47942764855517)};
      Object.entries(optionVariants).forEach(([key,v]) => {
        if (key !== 'dpn') this.querySelector('[data-needle-title="'+key+'"]').textContent = this.text(s.ownCable ? key+'_tips' : key);
        const cable = key === 'dpn' || s.ownCable ? null : this.variant(4,this.form.elements.kit_cable.value);
        this.querySelector('[data-option-price="'+key+'"]').textContent = v ? this.money(v.price + (cable?.price || 0)) + ' · ' + this.text(v.available && (!cable || cable.available) ? 'available' : 'unavailable') : this.text('unavailable');
      });
      const list = this.querySelector('[data-lines]');
      list.replaceChildren();
      s.items.forEach(item => { const li=document.createElement('li');const label=document.createElement('span');const price=document.createElement('span');label.textContent=item.label;price.textContent=item.variant?this.money(item.variant.price*item.quantity):'—';li.append(label,price);list.append(li); });
      this.querySelector('[data-empty]').hidden = s.ready;
      this.querySelector('[data-total]').textContent = s.ready ? this.money(s.items.reduce((sum,item)=>sum+(item.variant?.price||0)*item.quantity,0)) : '—';
      const problems = this.stockProblems(s);
      this.button.disabled = !s.ready || problems.length>0 || this.busy || this.locked;
      this.button.textContent = this.busy ? this.text('checking') : s.ready ? this.text(patternOnly ? 'add_pattern' : 'add') : this.text('select_first');
      if (problems.length && !this.busy && !this.locked) this.status.textContent = problems.join('\n');
      return s;
    }
    async refresh() {
      const url = new URL(location.href);
      url.searchParams.set('section_id',this.dataset.sectionId);
      const response=await fetch(url,{cache:'no-store',credentials:'same-origin'});
      if(!response.ok)throw new Error('refresh');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const data=doc.querySelector('[data-kit-data]');
      if(!data)throw new Error('refresh');
      this.data=JSON.parse(data.textContent);
    }
    async addProject() {
      if(this.busy||this.locked)return;
      const initial=this.render();
      if(!initial.ready||this.button.disabled)return;
      const initialTotal=initial.items.reduce((sum,item)=>sum+item.variant.price*item.quantity,0);
      this.busy=true;this.form.inert=true;this.status.textContent='';this.render();
      let attempted=false;
      try {
        await this.refresh();
        const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
        const cartResponse=await fetch(root+'cart.js',{cache:'no-store',credentials:'same-origin'});
        if(!cartResponse.ok)throw new Error('refresh');
        const cart=await cartResponse.json();
        const current=this.selection();
        const problems=this.stockProblems(current,cart);
        if(problems.length){this.status.textContent=problems.join('\n');return;}
        const total=current.items.reduce((sum,item)=>sum+item.variant.price*item.quantity,0);
        if(total!==initialTotal){this.status.textContent=this.text('changed_price');return;}
        const group='titchwell-'+crypto.randomUUID();
        const sizeLabel=current.mode === 'pattern' ? null : this.form.elements.kit_size.selectedOptions[0].textContent;
        const items=current.items.map(item=>({id:item.variant.id,quantity:item.quantity,properties:{Project:'Rowan Titchwell',...(sizeLabel ? {Size:sizeLabel} : {Purchase:'Pattern only'}),_rowan_project:group}}));
        attempted=true;
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok||!Array.isArray(result.items)||result.items.length!==items.length)throw new Error('cart');
        const verify=await fetch(root+'cart.js',{cache:'no-store',credentials:'same-origin'});
        if(!verify.ok)throw new Error('cart');
        const after=await verify.json();
        const complete=items.every(item=>after.items.filter(line=>line.properties?._rowan_project===group&&Number(line.variant_id)===Number(item.id)).reduce((sum,line)=>sum+line.quantity,0)===item.quantity);
        if(!complete)throw new Error('cart');
        this.locked=true;this.status.textContent=this.text(current.mode === 'pattern' ? 'added_pattern' : 'added');this.cartLink.hidden=false;
        document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:'titchwell',mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch(error) {
        this.status.textContent=this.text(attempted?'error':'refresh_error');
        if(attempted){this.locked=true;this.cartLink.hidden=false;}
      } finally {this.busy=false;this.form.inert=false;this.render();}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-project-builder"]) return;
  try {
    
if (!customElements.get('rowan-project')) {
customElements.define('rowan-project', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label+' cm'})),this.t('choose_size'));
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.populate('kit_yarn',this.config.yarns.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-yarn-wrap]').hidden=this.config.yarns.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.config.heldDouble?this.t('held_double'):this.t('shade_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      if(event.target.name==='kit_yarn')this.drawShades();
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const yarn=this.config.yarns[Number(this.form.elements.kit_yarn.value)];
    const product=this.product(yarn.handle);const list=this.querySelector('.rk-shades');list.replaceChildren();
    this.querySelector('[data-shade-name]').textContent=this.t('choose_shade');
    product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade';input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
    });
  }
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),yarnIndex=Number(f.get('kit_yarn')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const yarn=this.variant(f.get('kit_shade'));const counts=this.config.styles[style]?.counts;
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&!!counts&&!!yarn&&this.product(this.config.yarns[yarnIndex].handle).variants.some(v=>v.id===yarn.id);
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      items.push({variant:yarn,quantity:counts[size],label:counts[size]+' × '+this.config.yarns[yarnIndex].label+' · '+yarn.title});
      if(needle!=='none')this.config.packages[needle].filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x)items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,yarn,needle,ownCable,balls:ready?counts[size]:0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key))grouped.get(key).quantity+=x.quantity;else grouped.set(key,{...x});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const hasCables=Object.values(this.config.packages).some(pack=>pack.some(x=>x.kind==='cable'));
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize),style=Number(this.form.elements.kit_style.value);
    fit.textContent=rawSize===''?'':this.t('finished_chest')+' '+this.config.finished[si]+'cm · '+this.config.styles[style].counts[si]+' '+this.t('balls');
    if(s.yarn)this.querySelector('[data-shade-name]').textContent=s.yarn.title;
    for(const brand of ['zing','symfonie']){
      const pack=this.config.packages[brand].filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.config.packages[s.needle].filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-project'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.config.sizes[selection.size]+' cm';
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>({id:x.variant.id,quantity:x.quantity,properties}));
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.config.sizes[current.size]+' cm';
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-project-options"]) return;
  try {
    
if (!customElements.get('rowan-project-options')) {
customElements.define('rowan-project-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:slot.counts[size]}));
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.map(x=>x.label+': '+this.ballQuantity(x.counts[si])).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(slot.counts[si]));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-project-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-style-options"]) return;
  try {
    
if (!customElements.get('rowan-style-options')) {
customElements.define('rowan-style-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-style-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-wrap-builder"]) return;
  try {
    
if (!customElements.get('rowan-wrap-project')) {
customElements.define('rowan-wrap-project', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});
    // Browsers can restore form controls after pageshow without firing change.
    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:slot.counts[size]}));
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.config.packages[needle].filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x)items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const hasCables=Object.values(this.config.packages).some(pack=>pack.some(x=>x.kind==='cable'));
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.map(x=>x.label+': '+this.ballQuantity(x.counts[si])).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(slot.counts[si]));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    for(const brand of ['zing','symfonie']){
      const pack=this.config.packages[brand].filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.config.packages[s.needle].filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('rowan-wrap-project'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._rowan_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.config.sizes[selection.size]+' · '+this.config.finished[selection.size];
    const properties={Project:'Rowan '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_rowan_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='rowan-mip'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.config.sizes[current.size]+' · '+this.config.finished[current.size];
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._rowan_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('rowan:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sirdar-style-options"]) return;
  try {
    
if (!customElements.get('sirdar-style-options')) {
customElements.define('sirdar-style-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});

    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('sirdar-style-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._sirdar_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Sirdar '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_sirdar_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='sirdar-'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._sirdar_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('sirdar:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watg-style-options"]) return;
  try {
    
if (!customElements.get('watg-style-options')) {
customElements.define('watg-style-options', class extends HTMLElement {
  connectedCallback() {
    if(this.initialized)return;
    this.initialized=true;
    this.data=JSON.parse(this.querySelector('[data-kit-data]').textContent);
    this.config=JSON.parse(this.querySelector('[data-project-config]').textContent);
    this.querySelectorAll('[data-copy]').forEach(node=>{node.textContent=this.t(node.dataset.copy);});
    this.form=this.querySelector('form');this.button=this.querySelector('.rk-add');this.status=this.querySelector('[data-status]');this.cartLink=this.querySelector('.rk-view-cart');
    this.busy=false;this.locked=false;this.completed=false;this.uncertain=false;this.cartSnapshot={items:[]};
    if(this.data.handle!==this.config.handle){this.status.textContent=this.t('config_error');return;}
    this.querySelectorAll('[data-gallery-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const hero=this.querySelector('.rk-hero');hero.removeAttribute('srcset');hero.src=thumb.dataset.gallerySrc;hero.alt=thumb.dataset.galleryAlt;hero.classList.add('rk-gallery-selected');
      this.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));
    }));
    this.populate('kit_size',this.config.sizes.map((label,i)=>({value:i,label:label}))); 
    this.populate('kit_style',this.config.styles.map((x,i)=>({value:i,label:x.label})));
    this.querySelector('[data-style-wrap]').hidden=this.config.styles.length===1;
    this.querySelector('[data-yarn-help]').textContent=this.t('colour_help');
    this.querySelector('[data-cable-help]').textContent=this.config.cableNote;
    this.config.notions.forEach((x,i)=>{
      const label=document.createElement('label');label.className='rk-choice';
      const input=document.createElement('input');input.type='checkbox';input.name='kit_notion';input.value=i;
      const span=document.createElement('span');span.textContent=x.label;
      const small=document.createElement('small');small.dataset.notionPrice=i;span.append(small);label.append(input,span);this.querySelector('[data-notions]').append(label);
    });
    this.drawShades();
    this.form.addEventListener('change',event=>{
      if(event.target.name==='kit_size'){this.form.elements.kit_own_cable.checked=false;this.querySelectorAll('[name=kit_notion]').forEach(input=>{if(!this.notionFor(this.config.notions[Number(input.value)],Number(event.target.value)))input.checked=false;});}
      if(this.busy||this.uncertain)return;
      if(this.completed){this.locked=false;this.completed=false;}
      this.status.textContent='';this.render();
    });
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addProject();});

    window.addEventListener('pageshow',()=>setTimeout(()=>{if(this.isConnected&&!this.busy)this.render();},0));
    this.render();
  }
  t(key){return this.config?.copy?.[key]||this.data.strings[key]||key;}
  ballQuantity(n){return n+' '+this.t(n===1?'ball':'balls');}
  money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-NZ',{style:'currency',currency:this.data.currency||'NZD'}).format(n/100);}
  product(handle){return this.data.products.find(p=>p.handle===handle);}
  variant(id){return this.data.products.flatMap(p=>p.variants).find(v=>String(v.id)===String(id));}
  populate(name,options,placeholder){
    const select=this.form.elements[name];select.replaceChildren();
    if(placeholder){const o=new Option(placeholder,'');select.add(o);}
    options.forEach(x=>select.add(new Option(x.label,String(x.value))));
  }
  drawShades(){
    const slots=this.querySelector('[data-colour-slots]');slots.replaceChildren();
    this.config.colourSlots.forEach((slot,index)=>{
      const group=document.createElement('fieldset');group.className='rk-colour-slot';group.dataset.colourSlot=index;
      const legend=document.createElement('legend');legend.textContent=slot.label;
      const help=document.createElement('p');help.className='rk-help';help.textContent=slot.reference;
      const selected=document.createElement('p');selected.className='rk-shade-name';selected.dataset.slotSelected=index;selected.setAttribute('aria-live','polite');
      const list=document.createElement('div');list.className='rk-shades';
      group.append(legend,help,selected,list);slots.append(group);
      const product=this.product(slot.handle);
      product.variants.forEach(v=>{
      const label=document.createElement('label');label.className='rk-shade';
      const input=document.createElement('input');input.type='radio';input.name='kit_shade_'+index;input.value=String(v.id);input.required=true;
      const span=document.createElement('span');const img=document.createElement('img');img.src=v.image||product.image;img.alt=v.title;img.width=60;img.height=60;img.loading='lazy';
      const caption=document.createElement('span');caption.textContent=v.title+(v.available?'':' · '+this.t('unavailable'));span.append(img,caption);label.append(input,span);list.append(label);
      });
    });
  }
  yarnCount(slot,size,style=Number(this.form.elements.kit_style.value||0)){return (slot.countsByStyle?.[style]||slot.counts)[size];}
  packageFor(brand,size){return this.config.packagesBySize?.[brand]?.[size]||this.config.packages[brand]||[];}
  notionFor(item,size){return !item.sizes||item.sizes.includes(size);}
  cartLabel(size){return this.config.cartLabels?.[size]||this.config.sizes[size]+' · '+this.config.finished[size];}
  selection(){
    const f=new FormData(this.form),mode=f.get('kit_mode');
    if(mode==='pattern')return {mode,ready:true,items:[{variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')}],size:-1,style:0};
    const size=f.get('kit_size')===''?-1:Number(f.get('kit_size'));
    const style=Number(f.get('kit_style')||0),needle=f.get('kit_needles'),ownCable=needle!=='none'&&this.form.elements.kit_own_cable.checked;
    const colours=this.config.colourSlots.map((slot,index)=>({slot,variant:this.variant(f.get('kit_shade_'+index)),quantity:this.yarnCount(slot,size,style)})).filter(x=>x.quantity!==0);
    const ready=Number.isInteger(size)&&size>=0&&size<this.config.sizes.length&&colours.length>0&&colours.every(x=>x.variant&&Number.isInteger(x.quantity)&&x.quantity>0&&this.product(x.slot.handle).variants.some(v=>v.id===x.variant.id));
    const items=[];
    if(ready){
      if(f.has('kit_pattern'))items.push({variant:this.variant(this.config.patternId),quantity:1,label:this.t('pattern_line')});
      colours.forEach(x=>items.push({variant:x.variant,quantity:x.quantity,colourRole:x.slot.label,label:x.slot.label+': '+x.quantity+' × '+x.slot.yarnLabel+' · '+x.variant.title}));
      if(needle!=='none')this.packageFor(needle,size).filter(x=>!ownCable||x.kind!=='cable').forEach(x=>items.push({...x,variant:this.variant(x.id)}));
      f.getAll('kit_notion').forEach(i=>{const x=this.config.notions[Number(i)];if(x&&this.notionFor(x,size))items.push({...x,variant:this.variant(x.id)});});
    }
    return {mode,ready,items,size,style,colours,needle,ownCable,balls:ready?colours.reduce((sum,x)=>sum+x.quantity,0):0};
  }
  aggregate(items){
    const grouped=new Map();
    items.forEach(x=>{const key=String(x.variant?.id||x.id);if(grouped.has(key)){const item=grouped.get(key);item.quantity+=x.quantity;if(x.colourRole){item.colourRoles.push(x.colourRole);item.label=item.colourRoles.join(' + ')+' · '+x.variant.title;}}else grouped.set(key,{...x,colourRoles:x.colourRole?[x.colourRole]:[]});});
    return [...grouped.values()];
  }
  stockProblems(selection,cart={items:[]}){
    return this.aggregate(selection.items).flatMap(item=>{
      const v=item.variant;
      if(!v||!v.available)return [item.label+': '+this.t('unavailable')];
      const existing=cart.items.filter(x=>String(x.variant_id)===String(v.id)).reduce((sum,x)=>sum+x.quantity,0);
      if(v.tracked&&v.policy!=='continue'&&v.quantity-existing<item.quantity)return [item.label+': '+this.t('stock_needed')+' '+item.quantity+'; '+this.t('stock_remaining')+' '+Math.max(0,v.quantity-existing)+'.'];
      return [];
    });
  }
  render(){
    const selectedSize=Number(this.form.elements.kit_size.value);
    const duplicatePackages=JSON.stringify(this.packageFor('zing',selectedSize))===JSON.stringify(this.packageFor('symfonie',selectedSize));
    const secondPackage=this.querySelector('[name=kit_needles][value=symfonie]');
    secondPackage.closest('label').hidden=duplicatePackages;
    if(duplicatePackages&&secondPackage.checked)this.querySelector('[name=kit_needles][value=zing]').checked=true;
    const patternOnly=this.form.elements.kit_mode.value==='pattern';
    const fields=this.querySelector('[data-project-fields]');fields.hidden=patternOnly;fields.querySelectorAll('fieldset').forEach(x=>x.disabled=patternOnly||this.uncertain);
    this.querySelector('.rk-purchase').disabled=this.uncertain;
    this.querySelector('[data-pattern-note]').hidden=!patternOnly;
    const extras=this.querySelector('[data-required-extras]');
    if(extras){extras.textContent=this.config.requiredExtras||'';extras.hidden=patternOnly||!this.config.requiredExtras;}
    this.querySelector('[data-summary-title]').textContent=this.t(patternOnly?'pattern_summary':'summary_title');
    this.querySelector('[data-pattern-price]').textContent=this.money(this.variant(this.config.patternId)?.price||0);
    const s=this.uncertain&&this.pendingSelection?this.pendingSelection:this.selection();
    const viewSize=s.mode==='pattern'?Number(this.form.elements.kit_size.value):s.size;
    this.querySelector('[data-cable-help]').textContent=this.config.cableNotesBySize?.[viewSize]||this.config.cableNote;
    if(extras){const extra=this.config.requiredExtrasBySize?.[viewSize]||this.config.requiredExtras;extras.textContent=extra||'';extras.hidden=patternOnly||!extra;}
    const hasCables=s.needle&&s.needle!=='none'&&this.packageFor(s.needle,viewSize).some(x=>x.kind==='cable');
    for(const key of ['needle_help','notions_help','zing','symfonie']){const value=this.config.copyBySize?.[key]?.[viewSize]||this.t(key);this.querySelector('[data-copy="'+key+'"]').textContent=value;}
    this.config.notions.forEach((x,i)=>{const input=this.querySelector('[name=kit_notion][value="'+i+'"]');const applies=this.notionFor(x,viewSize);input.disabled=patternOnly||this.uncertain||!applies;input.closest('label').hidden=!applies;});
    this.querySelector('[data-cable-wrap]').hidden=patternOnly||s.needle==='none'||!hasCables;
    this.form.elements.kit_own_cable.disabled=patternOnly||s.needle==='none'||!hasCables;
    const fit=this.querySelector('[data-fit]');
    const rawSize=this.form.elements.kit_size.value,si=Number(rawSize);
    fit.textContent=rawSize===''?'':this.config.finished[si]+' · '+this.config.colourSlots.filter(x=>this.yarnCount(x,si)!==0).map(x=>x.label+': '+this.ballQuantity(this.yarnCount(x,si))).join(' · ');
    this.config.colourSlots.forEach((slot,index)=>{
      const active=this.yarnCount(slot,si)!==0;
      const group=this.querySelector('[data-colour-slot="'+index+'"]');group.hidden=!active;group.disabled=patternOnly||this.uncertain||!active;
      group.querySelectorAll('input').forEach(input=>{input.required=active&&!patternOnly;});
      const v=this.variant(this.form.elements['kit_shade_'+index].value);
      this.querySelector('[data-slot-selected="'+index+'"]').textContent=(v?v.title:this.t('choose_shade'))+(rawSize===''?'':' · '+this.ballQuantity(this.yarnCount(slot,si)));
    });
    const matching=s.colours&&s.colours.length>1&&s.colours.every(x=>x.variant)&&new Set(s.colours.map(x=>x.variant.id)).size<s.colours.length;
    this.querySelector('[data-same-shade]').hidden=patternOnly||!matching;
    this.querySelector('[data-yarn-help]').textContent=this.config.colourHelpByStyle?.[Number(this.form.elements.kit_style.value||0)]||this.t('colour_help');
    for(const brand of ['zing','symfonie']){
      const pack=this.packageFor(brand,viewSize).filter(x=>!this.form.elements.kit_own_cable.checked||x.kind!=='cable');
      const items=pack.map(x=>({...x,variant:this.variant(x.id)}));
      this.querySelector('[data-option-price="'+brand+'"]').textContent=this.money(items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0))+' · '+this.t(this.stockProblems({items},this.cartSnapshot).length?'some_unavailable':'available');
    }
    this.config.notions.forEach((x,i)=>{const v=this.variant(x.id);this.querySelector('[data-notion-price="'+i+'"]').textContent=this.money(v?.price||0)+' · '+this.t(this.stockProblems({items:[{...x,variant:v}]},this.cartSnapshot).length?'unavailable':'available');});
    const lines=this.querySelector('[data-lines]');lines.replaceChildren();
    s.items.forEach(x=>{const li=document.createElement('li'),label=document.createElement('span'),price=document.createElement('span');label.textContent=x.label;price.textContent=x.variant?this.money(x.variant.price*x.quantity):'—';li.append(label,price);lines.append(li);});
    const needleList=this.querySelector('[data-needle-list]');needleList.replaceChildren();
    if(s.needle&&s.needle!=='none')this.packageFor(s.needle,s.size).filter(x=>!s.ownCable||x.kind!=='cable').forEach(x=>{const li=document.createElement('li');li.textContent=x.label;needleList.append(li);});
    this.querySelector('[data-empty]').hidden=s.ready;
    this.querySelector('[data-total]').textContent=s.ready?this.money(s.items.reduce((sum,x)=>sum+(x.variant?.price||0)*x.quantity,0)):'—';
    const problems=this.stockProblems(s,this.cartSnapshot);
    this.button.disabled=!s.ready||problems.length>0||this.busy||this.locked;
    this.button.textContent=this.t(this.busy?'checking':this.locked?'review_cart':s.ready?(patternOnly?'add_pattern':'add'):'select_first');
    if(problems.length&&!this.busy&&!this.locked)this.status.textContent=problems.join('\n');
    return s;
  }
  async request(url,options={},format='json',attempts=2){
    for(let attempt=0;attempt<attempts;attempt++){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch(url,{cache:'no-store',credentials:'same-origin',...options,signal:controller.signal});
        if(!response.ok){
          const error=new Error('request');error.status=response.status;
          if(options.method==='POST'){
            try{const body=await response.json();if(typeof body.description==='string')error.description=body.description;}catch{}
          }
          throw error;
        }
        return await (format==='text'?response.text():response.json());
      }catch(error){
        const retryable=!error.status||error.status===408||error.status===429||error.status>=500;
        if(options.method==='POST'||!retryable||attempt+1===attempts)throw error;
        await new Promise(resolve=>setTimeout(resolve,200));
      }finally{clearTimeout(timer);}
    }
  }
  applyFresh(html){
    const doc=new DOMParser().parseFromString(html,'text/html'),root=doc.querySelector('watg-style-options'),node=root?.querySelector('[data-kit-data]'),configNode=root?.querySelector('[data-project-config]');
    if(!node||!configNode)throw new Error('refresh');
    const next=JSON.parse(node.textContent),config=JSON.parse(configNode.textContent);
    if(next.handle!==this.config.handle||!Array.isArray(next.products)||next.products.some(p=>!Array.isArray(p.variants)))throw new Error('refresh');
    if(JSON.stringify(config)!==JSON.stringify(this.config)){const error=new Error('project_changed');error.projectChanged=true;throw error;}
    this.data=next;if(root.dataset.sectionId)this.dataset.sectionId=root.dataset.sectionId;
  }
  async refresh(){
    const url=new URL(location.href);url.hash='';url.searchParams.delete('sections');url.searchParams.set('view',this.config.suffix);url.searchParams.set('section_id',this.dataset.sectionId);
    try{this.applyFresh(await this.request(url,{},'text'));}
    catch(error){
      if(error.projectChanged)throw error;
      url.searchParams.delete('section_id');this.applyFresh(await this.request(url,{},'text'));
    }
  }
  async readCart(root){
    const cart=await this.request(root+'cart.js');if(!Array.isArray(cart?.items))throw new Error('refresh');return cart;
  }
  matchesCart(cart,items,group){
    const lines=cart.items.filter(line=>line.properties?._watg_project===group);
    return lines.length===items.length&&items.every(x=>lines.filter(line=>String(line.variant_id)===String(x.id)).reduce((sum,line)=>sum+line.quantity,0)===x.quantity);
  }
  cartItems(selection,group){
    const sizeLabel=selection.mode==='pattern'?null:this.cartLabel(selection.size);
    const properties={Project:'Wool and the Gang '+this.config.name,...(sizeLabel?{Size:sizeLabel,...(this.config.styles.length>1?{Style:this.config.styles[selection.style].label}:{})}:{Purchase:'Pattern only'}),_watg_project:group};
    return this.aggregate(selection.items).map(x=>{
      const colours=selection.colours?.filter(c=>c.variant.id===x.variant.id).map(c=>c.slot.label+': '+this.ballQuantity(c.quantity)).join('; ');
      return {id:x.variant.id,quantity:x.quantity,properties:{...properties,...(colours?{Colours:colours}:{})}};
    });
  }
  async addProject(){
    if(this.busy||this.locked)return;
    const initial=this.render();if(!initial.ready||this.button.disabled||!this.form.reportValidity())return;
    const initialTotal=initial.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
    this.busy=true;this.form.inert=true;this.status.textContent='';this.render();let attempted=false;
    try{
      await this.refresh();
      const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
      const cart=await this.readCart(root);this.cartSnapshot=cart;
      const current=this.selection(),problems=this.stockProblems(current,cart);
      if(!current.ready)throw new Error('refresh');
      if(problems.length){this.status.textContent=problems.join('\n');return;}
      const total=current.items.reduce((sum,x)=>sum+x.variant.price*x.quantity,0);
      if(total!==initialTotal){this.status.textContent=this.t('changed_price');return;}
      const group='watg-'+this.config.code+'-'+crypto.randomUUID();
      const sizeLabel=current.mode==='pattern'?null:this.cartLabel(current.size);
      const items=this.cartItems(current,group);
      this.pendingSelection=current;attempted=true;
      let writeError;
      try{await this.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})},'json',1);}catch(error){writeError=error;}
      const after=await this.readCart(root);this.cartSnapshot=after;
      if(!this.matchesCart(after,items,group)){
        if(writeError?.status>=400&&writeError.status<500&&!after.items.some(line=>line.properties?._watg_project===group)){
          attempted=false;this.status.textContent=writeError.description||this.t('cart_rejected');return;
        }
        throw new Error('cart');
      }
      this.locked=true;this.completed=true;this.status.textContent=this.t(current.mode==='pattern'?'added_pattern':'added');this.cartLink.hidden=false;
      document.dispatchEvent(new CustomEvent('watg:project-added',{detail:{project:this.config.name,mode:current.mode,size:sizeLabel,balls:current.balls,total,currency:this.data.currency}}));document.dispatchEvent(new CustomEvent('cart:refresh'));
    }catch(error){this.status.textContent=this.t(error.projectChanged?'project_changed':attempted?'error':'refresh_error');if(attempted){this.locked=true;this.uncertain=true;this.cartLink.hidden=false;}}
    finally{this.busy=false;this.form.inert=false;this.render();}
  }
});
}


  } catch(e) { console.error(e); }
})();
})();
